import React from 'react';
import SectionTitle from '../../content/SectionTitle';
import BillingAddressForm from '../../input/BillingAddressForm';
import { CountryAndStateSelectOption } from '../../../types/Configuration';

export const BillingAddressSectionTestId = 'BillingAddressSection-framework';

export type BillingAddressSectionProps = {
  canEditBilling?: boolean;
  countryOptions: CountryAndStateSelectOption[];
  startWithFormOpen?: boolean;
};

const BillingAddressSection: React.FC<BillingAddressSectionProps> = ({
  countryOptions,
  canEditBilling = true,
  startWithFormOpen,
}: BillingAddressSectionProps) => {
  return canEditBilling ? (
    <div data-testid={BillingAddressSectionTestId}>
      <SectionTitle className="mb-2">Billing Address</SectionTitle>
      <div className="px-2">
        <BillingAddressForm
          countryOptions={countryOptions}
          startWithFormOpen={startWithFormOpen}
        />
      </div>
    </div>
  ) : null;
};

export default BillingAddressSection;
